import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerAuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    // Currently this guard is only used for the wizard, which has an ID param
    // If it is self, the user may navigate if a USER token exists
    // If it is not, the user may navigate if a CUSTOMER token exists
    if (route.params.id === 'self') {
      const token = await this.authService.getDecodedUserToken();
      if (!token) {
        return this.router.parseUrl('/login');
      } else {
        return true;
      }
    } else {
      const token = await this.authService.getDecodedCustomerToken();
      if (!token) {
        return this.router.parseUrl('/clogin?id='+ route.params.id);
      } else {
        return true;
      }
    }
  }
  
}
